import { Award, Briefcase, Globe } from "lucide-react";
import { IMAGES } from "../../data/content";
import { Reveal } from "./Reveal";

const TRAITS = [
  {
    icon: Globe,
    title: "Native",
    text: "Arabic is every tutor's mother tongue — in the dialect you choose to learn.",
  },
  {
    icon: Award,
    title: "Qualified",
    text: "Trained and certified language teachers, not just native speakers.",
  },
  {
    icon: Briefcase,
    title: "Experienced",
    text: "Seasoned tutors of every level, from the first alphabet to advanced fluency.",
  },
];

export const Tutors = () => (
  <section id="tutors" className="border-y border-line bg-sand/50 py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2">
      <div>
        <Reveal>
          <p className="eyebrow">Our tutors</p>
          <h2 className="mt-3 font-serif text-3xl tracking-tight text-ink sm:text-4xl md:text-5xl">
            Native. Qualified.
            <br />
            <span className="italic text-pine">Experienced.</span>
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-ink-soft">
            Every tutor at London Empire Institution is a native Arabic speaker — qualified and
            experienced in teaching learners of every level and every age.
          </p>
        </Reveal>

        <div className="mt-10 space-y-2">
          {TRAITS.map((t, i) => (
            <Reveal key={t.title} delay={i * 0.1}>
              <div className="flex items-start gap-5 border-t border-line py-6 transition-colors duration-300 hover:bg-surface/60">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-pine text-paper">
                  <t.icon className="h-5 w-5" />
                </span>
                <div>
                  <h3 className="font-serif text-xl text-ink">{t.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-ink-soft">{t.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.15} y={36}>
        <div className="relative">
          <div className="overflow-hidden rounded-3xl border border-line">
            <img
              src={IMAGES.chalkboard}
              alt="Students learning in a classroom"
              className="h-[420px] w-full object-cover md:h-[560px]"
            />
          </div>
          <div className="absolute -bottom-6 left-6 right-6 rounded-2xl border border-gold/40 bg-surface p-5 shadow-xl md:left-10 md:right-auto md:max-w-sm">
            <p className="font-arabic text-xl leading-snug text-pine">
              العربية لغتي الأم
            </p>
            <p className="mt-1 text-xs text-ink-mute">
              &ldquo;Arabic is my mother tongue&rdquo; — the promise of every tutor you&apos;ll
              meet.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Tutors;
